import { forwardRef, Ref, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGSVGElement>

const UmbrellaIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" ref={ref} {...props}>
    <path
      fill="#0F487A"
      d="M8 1.733a.545.545 0 0 1-.559-.531V.53C7.441.238 7.691 0 8 0c.308 0 .558.238.558.53v.672c0 .293-.25.53-.558.53ZM9.431 16c-.468 0-.879-.153-1.196-.442-.615-.569-.682-1.482-.682-1.851v-5.61c0-.293.25-.53.557-.53.308 0 .558.237.558.53v5.61c0 .357.09.853.344 1.087.071.064.187.153.455.144.647-.02.665-.95.665-.99 0-.292.254-.526.557-.526.308 0 .554.238.554.531 0 .688-.366 2.005-1.74 2.047H9.43Z"
    />
    <path
      fill="#0F487A"
      d="M8 1.202s-3.003 2.53-3.27 7.992c0 .084-.108.131-.179.076C3.181 8.264 1.71 8.145.156 8.752c-.076.03-.16-.021-.156-.098.094-4.131 3.636-7.452 8-7.452ZM8 1.202s3.003 2.53 3.27 7.992c0 .084.107.131.179.076 1.37-1.006 2.842-1.125 4.395-.518.075.03.16-.021.156-.098-.094-4.131-3.636-7.452-8-7.452Z"
    />
    <path
      fill="#337AB8"
      d="M11.27 9.194C9.086 8 6.917 8 4.735 9.194c0-.2-.004-.187 0-.378C4.935 3.215 8 1.202 8 1.202s3.066 2.013 3.266 7.614c.01.19 0 .178 0 .378h.005Z"
    />
  </svg>
))

export default UmbrellaIcon
